<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img v-if="!getUser.image"
        src="../assets/img/avatars/6.jpg"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
      <img v-if="!!getUser.image" style="width: 35px;"
        :src="serverUrl+getUser.image"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
    </template>\
    <template slot="dropdown">
      <b-dropdown-header
        tag="div"
        class="text-center">
        <strong>Settings</strong>
      </b-dropdown-header>
      <b-dropdown-item to="/profile" ><i class="fa fa-user" />Profile</b-dropdown-item>
      <b-dropdown-item to="/help"><i class="fa fa-info-circle" />Help</b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="logout()"><i class="fa fa-lock" />Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import Models from '@/store/ORM/models.js';
import * as constants from '@/helpers/Constants.js';


export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 
      serverUrl : constants.serverUrl
    }
  },
  methods : {
    logout(){
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('loggedin');
      localStorage.removeItem('vuex');
      
      Models.Reference.deleteAll();
      Models.Supplier.deleteAll();
      Models.Specialist.deleteAll();
      Models.CreatedMenu.deleteAll();
      Models.Specialist.deleteAll();
      Models.Nutritionist.deleteAll();
      Models.Client.deleteAll();
      Models.Event.deleteAll();
      Models.Product.deleteAll();

      // this.$store.dispatch('UserModules/UpdateUser', null);
      // this.$store.dispatch('UserModules/UpdateToken', null);
      // this.$store.dispatch('UserModules/LogOut', null);
      // localStorage.setItem('loggedin', false);
      // setTimeout(() => {
        // this.$router.push({ name: 'Login' });
        let urls = window.location.href.split('#');
        window.open(urls[0],'_self');
      // }, 300);
    }
  },
  computed: {
    getUser(){
      return Models.Nutritionist.query().first();
    },
  }
}
</script>

<style>
ul.dropdown-menu{
  columns: auto;
}

.sidebar .nav-dropdown-toggle:before{
  width: 12px;
  height: 12px;
}

</style>